export default {
    ui: {
        not_selected: 'Not Selected',
        no_result: 'No Results',
        search_placeholder: 'Search...',
        vtagging_create: (tag) => `Add new tag "${tag}".`,
        upload_button: 'Upload File',
        upload_delete: 'Delete',
        upload_formats: 'Allowed Files',
        'upload_formats_image/png': 'PNG',
        'upload_formats_image/jpg': 'JPG',
        'upload_formats_application/pdf': 'PDF',
        'upload_formats_application/msword': 'DOC',
        'upload_formats_application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'DOCX',
        'upload_formats_application/vnd.ms-powerpoint': 'PPT',
        'upload_formats_application/vnd.openxmlformats-officedocument.presentationml.presentation': 'PPTX',
        'upload_formats_image/jpeg': 'JPEG',
        'upload_formats_video/mpeg': 'MPEG',
        'upload_formats_video/mp4': 'MP4',
        'upload_formats_video/x-msvideo': 'AVI',
        upload_max_size: maxSize => `max. ${maxSize}MB`,
        upload_limit: limit => `max. ${limit} Files`,
        vtable_no_data: 'No Results',
    },
    form: {
        cancel: 'Cancel',
        save: 'Save',
        submit: 'Submit',
        submit_saving: 'Saving',
        submit_success: 'Saved!',
        discard: 'Don\'t Save',
        unsaved_title: 'Unsaved Changes',
        unsaved_body: 'You have unsaved changes. Do you want to save before you leave this page?',
    },
    validation: {
        required: 'This field is required.',
        numeric: 'Please enter a valid number.',
        email: 'Please enter a valid email address.',
        default: 'The input is not valid.',
    },
    modal: {
        ok: 'Ok',
        confirm: 'Confirm',
        cancel: 'Cancel',
        confirm_title: 'Confirm',
        confirm_text: 'Are you sure?',
        error_title: 'Error',
        error_text: 'An unknown error occurred. Please try again later.',
    },
};